import * as styles from './mobileTicketCssDefs';
import { Button, Typography } from 'omakase';
import { IconTicket } from '@tock/icons';
import Anchor from 'components/Anchor';

export interface MobileTicketProps {
  /**
   * Location where user can download an event ticket to their apple wallet
   */
  appleWalletUrl: string;
  /**
   * Location where user can download an event ticket QR code
   */
  mobileTicketUrl: string;
  /**
   * Callback fired when a user clicks on the apple wallet button
   */
  onAddToAppleWallet(): void;
  /**
   * True when adding to apple wallet is allowed
   */
  showAppleWallet: boolean;
  /**
   * Number of tickets purchased
   */
  ticketCount: number;
}

/**
 * Presentation component to render event ticket details and download links.
 */
export const MobileTicket: React.FC<MobileTicketProps> = ({
  appleWalletUrl,
  mobileTicketUrl,
  onAddToAppleWallet,
  showAppleWallet,
  ticketCount,
}) => {
  const ticketLabel = ticketCount > 1 ? 'tickets' : 'ticket';

  return (
    <div css={styles.layoutContainer}>
      <div>
        <Typography variant="heading04" mb={1} css={styles.headingWithAdornment}>
          <IconTicket />
          Bring your {ticketLabel}
        </Typography>
        <Typography variant="body02">
          Your {ticketLabel} {ticketCount > 1 ? 'are' : 'is'} available for download. Please save or
          print your {ticketLabel} to check in at the event.
        </Typography>
      </div>

      <div css={styles.actionsContainer}>
        <Button component={Anchor} variant="basic" size="medium" href={mobileTicketUrl}>
          View {ticketLabel}
        </Button>

        {showAppleWallet && (
          <Anchor
            target="_blank"
            href={appleWalletUrl}
            download
            css={styles.appleWalletButton}
            onClick={onAddToAppleWallet}
          >
            <img
              src="https://storage.googleapis.com/tock-public-assets/apple-wallet/button.svg"
              alt="Add to Apple Wallet"
            />
          </Anchor>
        )}
      </div>
    </div>
  );
};
